// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"152":"e352b5cd","453":"d8ef9ae6","610":"fcc170f1","696":"9336888d","874":"2fd4b990"}[chunkId] + ".chunk.js");